export function trackEvent(name: string, attrs?: Record<string, any>) {
  const payload = { event: name, ...attrs }
  if (typeof window !== 'undefined') {
    // @ts-ignore
    window.dataLayer = window.dataLayer || []
    // @ts-ignore
    window.dataLayer.push(payload)
  }
  console.debug('[Analytics]', name, attrs)
}
